import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m18.008 4.826-13.97 5.978 4.609 3.123zm-9.823 10.6L2.44 11.533a1 1 0 0 1 .168-1.748l18-7.702a1 1 0 0 1 1.37 1.133l-3.79 17.33a1 1 0 0 1-1.537.615l-4.272-2.894-2.382 3.3c-.567.788-1.81.386-1.81-.584zm2.95 2-1.45 2.01v-2.994zm-1.22-2.64L20.07 4.913l-3.19 14.592z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }